import { PageRequest } from '@/core/request/PageRequest';
import { SubArea } from '../SubAreas/SubAreas.types';

export interface TaskPrice {
  companyId: number;
  companyName?: string;
  id: number;
  price: number;
  priceFixed: number;
  commissionPercentage: number;
}

export interface Task {
  active: boolean;
  description: string;
  id: number;
  lifespan: number;
  maintenanceKm: number;
  maintenanceTime: number;
  note: string;
  subArea: SubArea;
  taskPriceSet: Omit<TaskPrice, 'companyName'>[];
  temparioCode: string;
  time: number;
  unit: string;
  applicationExecutionTime?: number;
  nbsCode?: string;
}

export interface TaskReduced {
  description: string;
  id: number;
  subAreaName: string;
  temparioCode: string;
}

export type TaskQueryOrderType = 'CODE' | 'DESCRIPTION';

export enum TaskQueryOrderColumn {
  Code = 'CODE',
  Description = 'DESCRIPTION',
}

export interface TasksQuery extends PageRequest {
  active?: boolean;
  companyId?: number;
  description?: string;
  temparioCode?: string;
  modelId?: number;
  search?: string;
  subAreaId?: number;
  taskOrder?: TaskQueryOrderColumn;
  isSpecificFilter?: boolean;
}

export interface CreateTaskRequest {
  active: boolean;
  description: string;
  lifespan: number;
  maintenanceKm: number;
  maintenanceTime: number;
  note: string;
  subArea: {
    id: number;
  };
  taskPriceSet: {
    companyId: number;
    price: number;
    priceFixed?: number;
  }[];
  temparioCode: string;
  time: number;
  unit: string;
  nbsCode?: string;
}

export interface UpdateTaskRequest {
  active: boolean;
  description: string;
  id: number;
  lifespan: number;
  maintenanceKm: number;
  maintenanceTime: number;
  note: string;
  subAreaId: number;
  taskPriceSet: TaskPrice[];
  temparioCode: string;
  time: number;
  unit: string;
  nbsCode?: string;
}

export interface UpdateAllTaskRequest {
  companyIds?: number[];
  price?: number;
  pricePercent?: number;
  subAreaId?: number;
  operation?: OperationType;
}

export interface UpdateTaskRequestWithSubAreaId extends UpdateTaskRequest {
  subArea: { id: number };
}

export enum OperationType {
  PRICE = 'PRICE',
  PERCENT = 'PERCENT',
  FIXED_PRICE = 'FIXED_PRICE',
}
